import React from 'react';

export function FieldRequiredHint() {
  return <span className="required">*</span>;
}
